module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gd-Hc-Ia.4ff43e79.png";